import React from "react";
import { Container } from "react-bootstrap";

export default function VenueTable({ venues }) {
  return (
    <Container style={{ padding: "20px", overflow: "auto" }}>
      <table
        className="table table-bordered"
        style={{
          border: "2px solid black",
          borderCollapse: "collapse",
          boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
          borderRadius: "10px", // Added rounded border
          overflow: "hidden", // Ensures the border radius is applied properly
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                textAlign: "center",
                backgroundColor: "black",
                color: "white",
                border: "1px solid black",
                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                fontWeight: "bold", // Make font bold
              }}
            >
              जिला
            </th>
            <th
              style={{
                textAlign: "center",
                backgroundColor: "black",
                color: "white",
                border: "1px solid black",
                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                fontWeight: "bold", // Make font bold
              }}
            >
              स्थल
            </th>
            <th
              style={{
                textAlign: "center",
                backgroundColor: "black",
                color: "white",
                border: "1px solid black",
                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                fontWeight: "bold", // Make font bold
              }}
            >
              खेल
            </th>
            <th
              style={{
                textAlign: "center",
                backgroundColor: "black",
                color: "white",
                border: "1px solid black",
                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                fontWeight: "bold", // Make font bold
              }}
            >
              अस्पताल
            </th>
            <th
              style={{
                textAlign: "center",
                backgroundColor: "black",
                color: "white",
                border: "1px solid black",
                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                fontWeight: "bold", // Make font bold
              }}
            >
              अस्पताल संपर्क सूत्र
            </th>
            <th
              style={{
                textAlign: "center",
                backgroundColor: "black",
                color: "white",
                border: "1px solid black",
                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                fontWeight: "bold", // Make font bold
              }}
            >
              नोडल अधिकारी NADA
            </th>
            <th
              style={{
                textAlign: "center",
                backgroundColor: "black",
                color: "white",
                border: "1px solid black",
                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                fontWeight: "bold", // Make font bold
              }}
            >
              नोडल अधिकारी मेडिकल
            </th>
            <th
              style={{
                textAlign: "center",
                backgroundColor: "black",
                color: "white",
                border: "1px solid black",
                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                fontWeight: "bold", // Make font bold
              }}
            >
              आपातकालीन संपर्क सूत्र
            </th>
          </tr>
        </thead>
        <tbody>
          {venues &&
            Object.keys(venues).map((category, index) =>
              venues[category].events.map((venue, venueIndex) => (
                <React.Fragment key={`${index}-${venueIndex}`}>
                  <tr>
                    {venueIndex === 0 && (
                      <td
                        rowSpan={venues[category].events.reduce(
                          (sum, v) => sum + v.games.length,
                          0
                        )}
                        style={{
                          verticalAlign: "middle",
                          textAlign: "center",
                          border: "1px solid black",
                          boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                          fontWeight: "bold", // Make font bold
                        }}
                      >
                        {venues[category]?.name}
                      </td>
                    )}
                    <td
                      style={{
                        verticalAlign: "middle",
                        border: "1px solid black",
                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                        fontWeight: "bold", // Make font bold
                      }}
                      rowSpan={venue.games.length}
                    >
                      {venue.venue}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                        fontWeight: "bold", // Make font bold
                      }}
                    >
                      {venue.games[0]}
                    </td>
                    <td
                      style={{
                        verticalAlign: "middle",
                        border: "1px solid black",
                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                        fontWeight: "bold", // Make font bold
                      }}
                      rowSpan={venue.games.length}
                    >
                      {venue.hospitalName}
                    </td>
                    <td
                      style={{
                        verticalAlign: "middle",
                        border: "1px solid black",
                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                        whiteSpace: "pre-wrap", // Ensures \n appears as a new line
                        fontWeight: "bold", // Make font bold
                      }}
                      rowSpan={venue.games.length}
                    >
                      {venue.hospitalContactPerson}
                    </td>
                    {venueIndex === 0 && (
                      <>
                        <td
                          rowSpan={venues[category].events.reduce(
                            (sum, v) => sum + v.games.length,
                            0
                          )}
                          style={{
                            verticalAlign: "middle",
                            textAlign: "center",
                            border: "1px solid black",
                            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                            fontWeight: "bold", // Make font bold
                          }}
                        >
                          {venues[category].nodalOfficerNADA}
                        </td>
                        <td
                          rowSpan={venues[category].events.reduce(
                            (sum, v) => sum + v.games.length,
                            0
                          )}
                          style={{
                            verticalAlign: "middle",
                            textAlign: "center",
                            border: "1px solid black",
                            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                            fontWeight: "bold", // Make font bold
                          }}
                        >
                          {venues[category].nodalOfficerMedical}
                        </td>
                        <td
                          rowSpan={venues[category].events.reduce(
                            (sum, v) => sum + v.games.length,
                            0
                          )}
                          style={{
                            verticalAlign: "middle",
                            textAlign: "center",
                            border: "1px solid black",
                            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                            fontWeight: "bold", // Make font bold
                          }}
                        >
                          {venues[category].emergencyMedicalContactNumber}
                        </td>
                      </>
                    )}
                  </tr>
                  {venue.games.slice(1).map((game, gameIndex) => (
                    <tr key={`${index}-${venueIndex}-${gameIndex}`}>
                      <td
                        style={{
                          border: "1px solid black",
                          boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                          fontWeight: "bold", // Make font bold
                        }}
                      >
                        {game}
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))
            )}
        </tbody>
      </table>
    </Container>
  );
}
